module.exports = __webpack_public_path__ + "static/img/illustratepic_01.c91ad84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ja/illustratepic_01.png
// module id = gB0j
// module chunks = 1